module.exports = __webpack_public_path__ + "static/media/logout-default.15233c87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/logout-default.svg
// module id = 1222
// module chunks = 0